<template>
  <v-layout row wrap>
    <v-flex xs3>
      <v-text-field
        v-model="discountCode"
        :label="'app.discount_codes.discount_code' | trans"
        :error-messages="error"
        :success-messages="successMessage"
      ></v-text-field>
    </v-flex>
    <v-flex xs4>
      <v-btn color="success" @click="checkDiscountCode">
        {{ 'app.discount_codes.add_code' | trans }}
      </v-btn>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  props: {
    error: String,
    successMessage: {
      type: [String, Array],
      default: null,
    },
  },
  data() {
    return {
      discountCode: '',
    };
  },
  methods: {
    checkDiscountCode() {
      this.$emit('checkDiscountCode', { discountCode: this.discountCode });
    },
  },
};
</script>

<style scoped></style>
